<template>
  <div class="mx-auto">
    <div class="flex items-center h-12 md:h-20">
      <h2 class="flex-none md:w-auto whitespace-no-wrap text-primary text-center md:text-right text-xl xl:text-2xl my-auto">
        {{section}}
      </h2>
      <div class="flex-grow h-px bg-gradient-to-r from-white to-primary"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    section: String
  },
  name: 'MiniHeader'
}
</script>
